import React, { Component, Fragment } from "react";
import { Router } from "react-router-dom";
import { StylesProvider } from "@material-ui/core/styles";
import "./App.scss";
import Routes from "./Routes";
import { init as initAnalytics } from "services/analytics";
import { init as initErrorReporting } from "services/error-reporting";
import { createBrowserHistory } from "history";
import { initNav } from "util/nav";
import ErrorPopUp from "components/ErrorPopUp";
import { createPreserveQueryHistory } from "util/routing";

const history = createPreserveQueryHistory(createBrowserHistory(), [/utm_.*/]);
initNav(history);
history.listen((location, action) => {
  if (action === "PUSH") {
    window.scrollTo(0, 0);
  }
});

class App extends Component<any, any> {
  componentDidMount(): void {
    initAnalytics();
    initErrorReporting();
  }

  render() {
    return (
      <StylesProvider injectFirst>
        <Fragment>
          <Router history={history}>
            <Routes />
          </Router>
          <ErrorPopUp />
        </Fragment>
      </StylesProvider>
    );
  }
}

export default App;
